import React, { useEffect, useState, useRef } from "react";
import styles from "@/components/CustomComponents/KecContent/index.module.scss";
import dynamic from "next/dynamic";
import { markerIcon } from "@/components/CustomComponents/KecContent/icons";

const ReactBingmaps = dynamic(
  () => import("react-bingmaps").then(mod => mod.ReactBingmaps),
  { ssr: false }
);

const KecContent = ({ kecContentData }) => {
  const [center, setCenter] = useState([]);
  const [showPopup, setShowPopup] = useState(null);
  const mapCurrentRef = useRef(null);
  const locationApi = process.env.NEXT_PUBLIC_LOCATION_API;
  const mapKey = process.env.NEXT_PUBLIC_MAP_KEY;
  const addressDescription = kecContentData?.description;
  const countryName = process.env.NEXT_PUBLIC_COUNTRY_NAME;
  const countryNameLocal = process.env.NEXT_PUBLIC_COUNTRY_LOCAL_NAME || "臺灣";
  const address = addressDescription?.match(
    new RegExp(`^(.*?(?:${countryNameLocal}|${countryName}))\\s*`, "i")
  )?.[1];

  const [mapReady, setMapReady] = useState(false);

  useEffect(() => {
    if (!addressDescription || !locationApi || !mapKey) {
      return;
    }

    const searchLocation = async () => {
      try {
        const url = `${locationApi}?query=${encodeURIComponent(addressDescription)}&key=${mapKey}`;
        const response = await fetch(url);

        if (!response.ok) return;

        const data = await response.json();
        const location =
          data.resourceSets?.[0]?.resources[0]?.geocodePoints?.[0]?.coordinates;

        if (!location) return;

        setCenter(location);
      } catch (err) {
        console.error(err);
      }
    };

    searchLocation();
  }, [addressDescription]);

  useEffect(() => {
    if (center.length === 2) {
      setMapReady(true);
    }
  }, [center]);

  const handlePushpinClick = e => {
    setShowPopup(prev => !prev);
  };
  const addressMap = address ? address : addressDescription;

  return (
    <>
      <div className={styles["horizontalrule-block"]}>
        <hr />
      </div>
      <div className="w-full max-w-screen-lg mx-auto flex flex-col gap-6 font-[HelveticaRoman,Helvetica,sans-serif] max-[979px]:px-8 mb-[5rem]">
        {/* --- Top Row --- */}
        <div className="flex flex-wrap w-full">
          {/* LEFT COLUMN */}
          <div className="w-full lg:w-7/12 flex flex-col gap-2">
            {kecContentData?.header && (
              <h2 className="text-[32px] m-0 mb-[0.5em] font-[HelveticaRoman,Helvetica,sans-serif] p-0 leading-[1.1em] font-[400] box-border text-[#232323]">
                {kecContentData?.header}
              </h2>
            )}

            {kecContentData?.description && (
              <p className="text-[16px] text-[#232323] leading-normal whitespace-pre-line">
                {kecContentData?.description}
              </p>
            )}
          </div>

          {/* SPACER */}
          <div className="hidden lg:block lg:w-1/12"></div>

          {/* RIGHT COLUMN */}
          <div className="w-full lg:w-4/12 flex flex-col gap-2">
            {(kecContentData?.phoneLabel || kecContentData?.phoneNumber) && (
              <p className="text-[16px] text-[#232323] leading-normal">
                {kecContentData?.phoneLabel && (
                  <strong className="font-[HelveticaBold,Helvetica,sans-serif] font-[500] leading-[22.85px]">
                    {kecContentData?.phoneLabel}:&nbsp;
                  </strong>
                )}
                {kecContentData?.phoneNumber}
              </p>
            )}

            {kecContentData?.businessLabel && (
              <p className="text-[16px] text-[#232323] leading-normal">
                <strong className="font-[HelveticaBold,Helvetica,sans-serif] font-[500] leading-[22.85px]">
                  {kecContentData?.businessLabel}:
                </strong>
              </p>
            )}

            {Array.isArray(kecContentData?.businessHours) &&
              kecContentData.businessHours.map((item, index) => (
                <p
                  key={index}
                  className="text-[16px] text-[#232323] leading-normal whitespace-pre-line"
                >
                  {item?.fields?.text}
                </p>
              ))}
          </div>
        </div>

        {/* MAP container */}
        <div className={styles.mapWrapper} ref={mapCurrentRef}>
          {mapReady && (
            <ReactBingmaps
              className={styles["react-bingmaps"]}
              bingmapKey={process.env.NEXT_PUBLIC_MAP_KEY}
              center={center}
              zoom={15}
              disableStreetside
              disableScrollWheelZoom
              navigationBarMode="square"
              mapOptions={{
                showMapTypeSelector: false,
                NavigationBarMode: "square",
              }}
              infoboxes={
                showPopup
                  ? [
                      {
                        location: center,
                        option: {
                          visible: true,
                          description: `<div class="customInfobox" style="
                                      width: 100%;height:100%;
                                      font-family: helveticaRoman;
                                      width:260px;
                                      max-width:260px;
                                      background:#ffffff;
                                      overflow:hidden;
                                      color:#888888;
                                      box-sizing:border-box;
            ">
                          <h3 style="display:flex;">
                            <span
                              style="display:flex;
                              margin-left:10px;
                                align-items:center;
                                justify-content:center;
                                font-weight:bold;
                                font-size:13px;
                                word-wrap:break-word">${kecContentData?.header}</span>
                            </h3>
                            <h3 style="margin-left:10px;word-break: break-all;
                                  white-space:normal;
                                  overflow:hidden;
            "> ${addressMap}
                           
                            </h3> 
                            
                          </div>
                        `,
                        },
                      },
                    ]
                  : []
              }
              pushPins={[
                {
                  location: center,
                  option: {
                    icon:
                      "data:image/svg+xml;charset=UTF-8," +
                      encodeURIComponent(markerIcon),
                    width: 24,
                    height: 34,
                  },
                  addHandler: {
                    type: "click",
                    callback: handlePushpinClick,
                  },
                },
              ]}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default KecContent;
